import { useState } from "react";
import { Ellipsis, Pencil, Trash2 } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import ACL_RELATIONSHIPS from "acl-relationships";
import { checkIsAuthorized } from "components/helpers";
import { invalidateRevenueOpportunityRecipientPresetsTableQuery } from "hooks/useRevenueOpportunityRecipientPresetsTable";
import DeleteRevenueOpportunityRecipientPresetModal from "routes/revenue_opportunity_recipient_presets/components/DeleteRevenueOpportunityRecipientPresetModal";
import RevenueOpportunityRecipientPresetModal from "routes/revenue_opportunity_recipient_presets/components/RevenueOpportunityRecipientPresetModal";

export function RevenueOpportunityRecipientPresetsTableActions({ original }) {
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const canEdit = checkIsAuthorized([
    ACL_RELATIONSHIPS.revenueOpportunityRecipientPreset.edit,
    ACL_RELATIONSHIPS.recipient.read,
  ]);
  const canDelete = checkIsAuthorized([
    ACL_RELATIONSHIPS.revenueOpportunityRecipientPreset.delete,
  ]);

  if (!canEdit && !canDelete) return null;

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          aria-label="Preset actions"
          className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
        >
          <Ellipsis />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {canEdit && (
            <DropdownMenuItem onClick={() => setEditOpen(true)}>
              <Pencil />
              Edit
            </DropdownMenuItem>
          )}
          {canDelete && (
            <DropdownMenuItem
              variant="destructive"
              onClick={() => setDeleteOpen(true)}
            >
              <Trash2 />
              Delete
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      <RevenueOpportunityRecipientPresetModal
        preset={original}
        open={editOpen}
        onOpenChange={setEditOpen}
        onSuccess={invalidateRevenueOpportunityRecipientPresetsTableQuery}
      />
      <DeleteRevenueOpportunityRecipientPresetModal
        preset={original}
        open={deleteOpen}
        onOpenChange={setDeleteOpen}
        onSuccess={invalidateRevenueOpportunityRecipientPresetsTableQuery}
      />
    </>
  );
}
